'use client';

import {Box, styled} from '@mui/material';

// A dark "colored rectangle" CTA card.
// Desktop: tall card with the icon stacked above a centred label.
// Mobile: short, full-width card with the icon on the left and the label
// centred in the remaining space (per design).
export const StyledHeroCtaCardRoot = styled(Box)(({theme}) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  width: '100%',
  height: 190,
  padding: theme.spacing(3, 2),
  borderRadius: theme.shape.borderRadiusMd,
  backgroundColor: theme.palette.tv4Red.red07,
  color: theme.palette.common.white,
  cursor: 'pointer',
  transition: 'transform 250ms ease, background-color 250ms ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    backgroundColor: theme.palette.tv4Red.red06,
  },
  '&:hover .hero-cta-card__icon': {
    transform: 'scale(1.06)',
  },
  '& .label': {
    color: theme.palette.common.white,
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: theme.spacing(3),
    height: 'auto',
    minHeight: 88,
    padding: theme.spacing(2, 3),
    '& .label': {
      flex: 1,
      textAlign: 'start',
    },
  },
}));

export const StyledHeroCtaCardIcon = styled(Box)(({theme}) => ({
  position: 'relative',
  flexShrink: 0,
  width: 96,
  height: 96,
  transition: 'transform 250ms ease',
  [theme.breakpoints.down('sm')]: {
    width: 64,
    height: 64,
  },
}));
